/* eslint-disable no-console */
import _ from 'underscore';
import { updateAssetUrlDimensions } from '../widen-utils';

_.templateSettings = {
  interpolate: /\{\{(.+?)\}\}/g,
};

let previewData = {};
let previewWrapperDiv = null;


const imageTemplate =
  `<button class="photos-modal-btn" aria-label="View larger version of this photo in the gallery modal">
    <img src="{{ src }}" alt="{{ alt }}" />
  </div>`;

const videoTemplate =
  `<div class="video-wrapper">
      <iframe src='{{ videosrc }}' allowfullscreen></iframe>
  </div>`;

const imageTemplateVals = _.template(imageTemplate);
const videoTemplateVals = _.template(videoTemplate);

const getLargeImageUrl = src => (
  updateAssetUrlDimensions({
    src,
    width: 755,
    height: 420, // 440,
  })
);

const getPreviewData = () => (
  previewData
);

const setPreviewData = (data) => {
  const { alt, caption, src, type, videosrc } = data;
  previewData = {
    alt,
    caption,
    src,
    type,
    videosrc,
  };
};

const addImage = (item, onAssetLoaded, onPreviewClick) => {
  const img = item.querySelector('img');
  // Set photo data object
  setPreviewData({
    alt: img.alt,
    caption: item.getAttribute('data-caption'),
    src: getLargeImageUrl(img.src),
    type: 'image',
  });
  const compiled = imageTemplateVals(getPreviewData());
  previewWrapperDiv.innerHTML = compiled;
  // On asset load
  const asset = previewWrapperDiv.querySelector('img');
  asset.addEventListener('load', () => {
    if (onAssetLoaded) {
      onAssetLoaded();
    }
  });
  // On asset/button click
  // Add trigger for photos modal
  const btn = previewWrapperDiv.querySelector('.photos-modal-btn');
  btn.addEventListener('click', onPreviewClick);
};

const addVideo = (item, onAssetLoaded) => {
  const img = item.querySelector('img');
  const compiled = videoTemplateVals({
    alt: img.alt,
    caption: item.getAttribute('data-caption'),
    src: getLargeImageUrl(img.src),
    type: 'video',
    videosrc: item.getAttribute('data-videosrc'),
  });
  previewWrapperDiv.innerHTML = compiled;
  if (onAssetLoaded) {
    onAssetLoaded();
  }
};

const updateWrapperHeight = () => {
  previewWrapperDiv.style.height = `${previewWrapperDiv.firstChild.offsetHeight}px`;
};

const init = (options) => {
  const { previewWrapper } = options;
  previewWrapperDiv = previewWrapper;
  window.addEventListener('resize', updateWrapperHeight);
};

const update = (options) => {
  const { item, onPreviewClick } = options;
  // Set height of wrapper = to height of image before loading
  updateWrapperHeight();
  const type = item.getAttribute('data-type');
  if (type === 'image') {
    addImage(item, updateWrapperHeight, onPreviewClick);
  } else if (type === 'video') {
    addVideo(item, updateWrapperHeight);
  }
};

export {
  getPreviewData,
  init,
  update,
};
/* eslint-enable no-console */
